/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: sitecatalyst.js
 */
$.namespace("SCS.sitecatalyst.downloadCenter");

SCS.sitecatalyst.downloadCenter = function(keyword, productTagTitle, productFamilyTagTitle, manufacturerTagTitle, totalMatches) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.t) {
		siteCatalyst.prop10 = keyword;
		siteCatalyst.prop11 = totalMatches;
		siteCatalyst.prop36 = 'Download:' + productFamilyTagTitle + '/' + manufacturerTagTitle + '/' + productTagTitle;
		siteCatalyst.linkTrackVars = 'prop10,prop11,prop36';
		siteCatalyst.t(this, 'o', siteCatalyst.prop10);
	}
};

/**
 * Initialize SiteCatalyst
 */
SCS.sitecatalyst.downloadCenter.init = function(keyword, catTag, subCatTag, totalMatches) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.t) {
		siteCatalyst.prop10 = keyword;
		siteCatalyst.prop11 = totalMatches;
		siteCatalyst.prop36 = catTag;

		siteCatalyst.linkTrackVars = 'prop10,prop11,prop36';
		siteCatalyst.linkTrackEvents = 'None';
		if (subCatTag != null)
			siteCatalyst.prop36 = subCatTag;
		siteCatalyst.t(this, 'o', siteCatalyst.prop10);
	}
};

SCS.sitecatalyst.downloadCenter.track = function(url, counter) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.t) {
		siteCatalyst.linkTrackVars += ",prop59";
		siteCatalyst.prop59 = counter;
		siteCatalyst.tl(this, 'o', siteCatalyst.prop59);
	}
};


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/sitecatalyst.js
// module id = 349
// module chunks = 0